/**
 * Shared client-side role hierarchy + minimum-role check.
 *
 * Mirrors the server's role ordering. Extracted from `router.tsx` so other
 * surfaces (e.g. the per-number duplicate marker on the contact card) can gate
 * UI on role without duplicating the hierarchy.
 */

export const ROLE_HIERARCHY = [
  'rep',
  'supervisor',
  'manager',
  'admin',
  'auditor',
  'csuite',
] as const;

export type Role = (typeof ROLE_HIERARCHY)[number];

/** True when `userRole` sits at or above `requiredRole` in the hierarchy. */
export function hasMinRole(userRole: string, requiredRole: string): boolean {
  const userIdx = ROLE_HIERARCHY.indexOf(userRole.toLowerCase() as Role);
  const reqIdx = ROLE_HIERARCHY.indexOf(requiredRole.toLowerCase() as Role);
  if (userIdx < 0 || reqIdx < 0) return false;
  return userIdx >= reqIdx;
}
